export const SET_ACTIVE_PRODUCT = 'SET_ACTIVE_PRODUCT';

export type ActiveProductState = {
  invoiceId: number;
  productId: number;
};
